<div class="banner" role="banner" [class.show-btn]="showBtn">
  <div class="container d-flex">
    <div class="banner-content">
      <div class="d-flex text-white align-items-center">
        <h1>{{ title }}</h1>
        @if (showBtn) {
          <i class="material-icons">chevron_right</i>
        }
      </div>
      <div class="d-flex text-white">
        <div class="text-start member-id">
          <span> {{ subtitle }}</span>
        </div>
      </div>
    </div>
    <div class="banner-logo ms-auto">
      <img [src]="'logos/rewards-logo.png' | contentAssetImage" alt="" class="src" />
    </div>
  </div>
</div>
